//GSAPにScrollTriggerプラグイン登録
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

window.addEventListener('DOMContentLoaded', function(){
  
  let eventType = 'click';

  //header上のアナウンスバーエリアサイズ取得 -------------------------
  const htmlElement = document.querySelector('html');
  const targetElement = document.querySelector('.shopify-section-group-header-group.announcement-bar-section');
  const targetHeaderMenu = document.querySelector('.header__icon--menu');
  targetHeaderMenu.addEventListener(eventType,() => {
    if (targetElement) {
      if (isInView(targetElement)) {
        //要素が画面内にある場合
        const height = targetElement.offsetHeight;
        htmlElement.setAttribute('style', `${htmlElement.getAttribute('style') || ''} --announcement-bar-height:${height}px;`);
      }
      else{
        //要素が画面内にない場合
        htmlElement.setAttribute('style', `${htmlElement.getAttribute('style') || ''} --announcement-bar-height:0px;`);
      }
    }
  });
  //END header上のアナウンスバーエリアサイズ取得 -------------------------
  
  document.querySelectorAll("#menu-drawer-bg").forEach((btn_bg) => {
    btn_bg.addEventListener("click", () => {
      const summaryToggle = document.querySelector("#Details-menu-drawer-container summary");
      summaryToggle.click();
    });
  });

  //商品詳細：追従処理
  const $productMainBottomFixed = document.getElementById('product-main_bottom__fixed');
  const $productMainBottom = document.getElementById('product-main_bottom');
  let denominator;
  if (window.innerWidth > 768) {
    //PC
    denominator = 1.5;
  } else {
    //SP
    denominator = 1.2;
  }
  
  if ($productMainBottom){ 
    //#$productMainBottom がある場合
    window.addEventListener('scroll', function () {
      const targetOffsetTop = $productMainBottom.offsetTop; 

      // Position add class
      if (window.scrollY > 150) {
        $productMainBottomFixed.classList.add('is-view');
      } else {
        $productMainBottomFixed.classList.remove('is-view');
      }

      // Position absolute
      if (window.scrollY + window.innerHeight / denominator >= targetOffsetTop) {
        $productMainBottomFixed.style.position = 'absolute';
        $productMainBottomFixed.style.bottom = 30  + 'px';
        $productMainBottomFixed.classList.add('is-absolute');
      } else {
        $productMainBottomFixed.style.position = '';
        $productMainBottomFixed.style.bottom = '';
        $productMainBottomFixed.classList.remove('is-absolute');
      }
    });
  }
  //END 商品詳細：追従処理
  
  //フローティングボタン有りの場合
  if(document.querySelector('#floating-btn-area') != null){
    document.querySelector('footer .footer-block--navi').classList.add('is-fixbanner-open');
  }
  //END フローティングボタン有りの場合
  
  //TWO CULTURE(story) / 商品一覧 SP時 GSAP横スクロール-----------------------------------------------
  /*
  const mobileMediaQuery = window.matchMedia('(max-width: 767px)');
  //
  const wrapper = document.querySelector(".js-products-list-grid-slide-wrap");
  const container = document.querySelector(".js-products-list-grid-slide");
  //
  const wrapper2 = document.querySelector(".js-better-high-in-story-slide-wrap");
  const container2 = document.querySelector(".js-better-high-in-story-slide");


  // GSAP：商品一覧：横スクロールアニメーション関数
  const animateHorizontalScrollProduct = () => {
    //console.log(container.scrollWidth - wrapper.clientWidth)
    console.log('gsap-product');
    //プロダクト
    //横幅を指定
    gsap.set(container, {
        width: 'calc(100% + 40px)' 
    });
    let productSlide = gsap.to(container, {
      xPercent: -100 * (container.children.length - 1), // 子要素数に応じて横移動
      ease: "none",
      scrollTrigger: {
        trigger: wrapper,
        pin: true,
        scrub: 1,
        // 横スクロール距離 = 横幅 - 画面幅
        end: () => "+=" + (container.scrollWidth - wrapper.clientWidth),
        invalidateOnRefresh: true
      }
    });
  }//END animateHorizontalScrollProduct


  // GSAP：TWO CULTURE(story)：横スクロールアニメーション関数
  const animateHorizontalScrollStory = () => {
    console.log('gsap-story');
    //ストーリー
    //横幅を指定
    gsap.set(container2, {
        width: 'calc(100% + 40px)' 
    });
    let storySlide = gsap.to(container2, {
      xPercent: -100 * (container2.children.length - 1), // 子要素数に応じて横移動
      ease: "none",
      scrollTrigger: {
        trigger: wrapper2,
        pin: true,
        scrub: 1,
        // 横スクロール距離 = 横幅 - 画面幅
        end: () => "+=" + (container2.scrollWidth - wrapper2.clientWidth),
        invalidateOnRefresh: true
      }
    });
  };//END animateHorizontalScrollStory

  
  // class名と処理をマッピング
  const execMap = {
    "js-products-list-grid-slide-wrap": animateHorizontalScrollProduct,
    "js-better-high-in-story-slide-wrap": animateHorizontalScrollStory,
  };

  
  // ロード時スマホ判定 / アニメーション実行
  if (mobileMediaQuery.matches) {
    // ページ上の要素順に処理を実行
    document.querySelectorAll('.js-products-list-grid-slide-wrap, .js-better-high-in-story-slide-wrap').forEach(el => {
      for (const cls in execMap) {
        if (el.classList.contains(cls)) {
          execMap[cls]();
        }
      }
    });
  }
  */
  
  // 画面幅の変更を監視:
  /*
  mobileMediaQuery.addEventListener('change', (e) => {
    window.location.reload();
  });
  */
  /*---------------------------------------------*/
});


//要素が画面内にあるかどうか
function isInView(el) {
  const rect = el.getBoundingClientRect();
  return (
    rect.top < window.innerHeight &&
    rect.bottom > 0
  );
}